module.exports = __webpack_public_path__ + "img/d200907-1.f4d330de.jpg";